/**
 * Restoring purchases is not supported on the web
 */
export function RestorePurchasesLink() {
  return null
}
